/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const LiveTrackingIcon = ({ isActive = false, className = "" }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }

  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      test-id="erYzxNXj"
    >
      <path
        d="M7.49997 10.9263C8.27203 10.9263 8.96826 10.7408 9.58867 10.3699C10.2091 9.99942 10.6985 9.51089 11.057 8.90427C10.5744 8.51334 10.0298 8.21326 9.42322 8.00405C8.81661 7.79537 8.17552 7.69103 7.49997 7.69103C6.82442 7.69103 6.18334 7.79537 5.57672 8.00405C4.9701 8.21326 4.42552 8.51334 3.94299 8.90427C4.30144 9.51089 4.79087 9.99942 5.41128 10.3699C6.03168 10.7408 6.72791 10.9263 7.49997 10.9263ZM7.49997 6.88221C7.95493 6.88221 8.34455 6.72368 8.66881 6.40662C8.99253 6.0901 9.15438 5.70942 9.15438 5.26456C9.15438 4.81971 8.99253 4.43902 8.66881 4.1225C8.34455 3.80544 7.95493 3.64692 7.49997 3.64692C7.04501 3.64692 6.65567 3.80544 6.33196 4.1225C6.00769 4.43902 5.84556 4.81971 5.84556 5.26456C5.84556 5.70942 6.00769 6.0901 6.33196 6.40662C6.65567 6.72368 7.04501 6.88221 7.49997 6.88221ZM7.49997 14.4447C9.18196 12.9349 10.4297 11.5631 11.2431 10.3294C12.0565 9.09623 12.4632 8.00108 12.4632 7.04397C12.4632 5.57461 11.984 4.37135 11.0255 3.43419C10.0676 2.49758 8.89243 2.02927 7.49997 2.02927C6.10751 2.02927 4.93205 2.49758 3.97359 3.43419C3.01569 4.37135 2.53674 5.57461 2.53674 7.04397C2.53674 8.00108 2.94345 9.09623 3.75686 10.3294C4.57028 11.5631 5.81799 12.9349 7.49997 14.4447ZM7.49997 16.5881C5.2803 14.7413 3.62258 13.0258 2.52681 11.4415C1.43049 9.85787 0.882324 8.39201 0.882324 7.04397C0.882324 5.02192 1.54767 3.41101 2.87837 2.21125C4.20852 1.0115 5.74905 0.411621 7.49997 0.411621C9.25089 0.411621 10.7914 1.0115 12.1216 2.21125C13.4523 3.41101 14.1176 5.02192 14.1176 7.04397C14.1176 8.39201 13.5697 9.85787 12.474 11.4415C11.3776 13.0258 9.71964 14.7413 7.49997 16.5881Z"
        fill={fill}
        test-id="gTc8wRzs"
      />
    </svg>
  );
};

export default LiveTrackingIcon;
